import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded'
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded'
import { Chip, Tooltip } from '@mui/material'

/**
 * Fuente/documento como elemento de confianza (sección 17 del encargo:
 * "GOVIA debe mostrar claramente de dónde proviene"). Mismo patrón visual
 * que `MessageBubble` ya usa para citas web vs. documento (Fase C) — se
 * formaliza aquí como primitiva para reutilizar en Territorio/Evidencia/
 * Decisión sin volver a escribir la distinción web/documento cada vez.
 */
export function EvidenceChip({
  label,
  type,
  snippet,
  href,
}: {
  label: string
  type: 'web' | 'document'
  snippet?: string
  href?: string
}) {
  const chip = (
    <Chip
      size="small"
      variant="outlined"
      icon={type === 'web' ? <LanguageRoundedIcon /> : <DescriptionRoundedIcon />}
      color={type === 'web' ? 'info' : 'default'}
      clickable={Boolean(href)}
      component={href ? 'a' : 'div'}
      href={href}
      target={href ? '_blank' : undefined}
      rel={href ? 'noopener noreferrer' : undefined}
      label={label}
      sx={{ maxWidth: 260 }}
    />
  )
  return snippet ? (
    <Tooltip title={snippet} arrow placement="top">
      {chip}
    </Tooltip>
  ) : (
    chip
  )
}
